// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const CollapsibleContract = contract({
  name: "Collapsible",
  description: "A single show/hide reveal — \"Show advanced settings\" rows, expandable inline help, \"More details\" sections inside cards. For multiple rows of expandable content where one-at-a-time matters, reach for Accordion. For a separate panel that floats above content, use Popover.",
  import: "@gradeui/ui",
  aliases: ["collapsible","expand","show more","disclosure","advanced settings","disclosure group","expandable section","expandable view","show hide"],
  subcomponents: ["CollapsibleTrigger","CollapsibleContent"],
  composesWith: ["Button (as the trigger","asChild)","Card (expandable settings group)","Row (header + chevron)"],
  props: {
  "open": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "controlled open state",
  },
  "defaultOpen": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "uncontrolled initial state",
  },
  "onOpenChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "the clickable header (often a Button asChild)",
  },
  },
});
